module.exports = __webpack_public_path__ + "media/images/logos/University-of-Antwerp-2ebbd63c509b2b43037842c955fa7a15.svg";